class LanguageSwitcher {

    constructor(element) {
        this.element = element;

        this.registerEventListeners()
    }

    registerEventListeners() {
        this.element.addEventListener("click", (e) => {
            // Don't close the menu if we click an item inside the button
            if (!e.target.classList.contains("js-language-switcher-option")) {
                this.element.classList.toggle("language-switcher--open")
            }
        })
    }
}

export default {
    init: () => {
        [...document.querySelectorAll(".js-language-switcher")].map((el) => {
            return new LanguageSwitcher(el);
        })
    }
}